import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { EPeriod, ERoomsCount } from 'shared/types/marketTrends';
import { initialState } from './initialState';

const filtersSlice = createSlice({
  initialState,
  name: 'marketTrendsFilters',
  reducers: {
    setRoomsCount: (state, action: PayloadAction<ERoomsCount>) => {
      state.roomsCount = action.payload;
    },
    setPeriod: (state, action: PayloadAction<EPeriod>) => {
      state.period = action.payload;
    },
  },
});

export const {
  reducer: filtersReducer,
  actions: { setRoomsCount, setPeriod },
} = filtersSlice;
